import { z } from 'zod'
import { ZugmeldestelleSchema } from '../../Generic/schema/generic.schema'
import { Betriebsstellenart } from '../../../../types'

// Default constants
const DEFAULT_AUFTRAG_23_10 = {
  enabled: true,
  field_23_11: {
    art: '' as '' | Betriebsstellenart,
    name: ''
  },
  field_23_12: {
    art: '' as '' | Betriebsstellenart,
    name: ''
  }
}

const DEFAULT_BEFEHL_23_FORM = {
  auftrag_23_10: DEFAULT_AUFTRAG_23_10
} as const

// Schema definitions
const Auftrag23_10Schema = z
  .object({
    enabled: z.boolean().default(DEFAULT_AUFTRAG_23_10.enabled),
    field_23_11: ZugmeldestelleSchema,
    field_23_12: ZugmeldestelleSchema
  })
  .default(() => structuredClone(DEFAULT_AUFTRAG_23_10))

// Base schema
const Befehl23FormSchemaBase = z
  .object({
    // Auftrag 23.10
    auftrag_23_10: Auftrag23_10Schema
  })
  .default(() => structuredClone(DEFAULT_BEFEHL_23_FORM))

export const Befehl23FormSchema = Befehl23FormSchemaBase

// Validation schema factory
export const createBefehl23FormValidationSchema = () => {
  return Befehl23FormSchemaBase
}

export type Befehl23FormData = z.infer<typeof Befehl23FormSchemaBase>
